import axios from 'axios';
import store from '@/store';
import storage from 'store';
// import { notification } from 'ant-design-vue';
import { VueAxios } from './axios';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import Vue from 'vue';
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 30000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    console.error('错误信息:', error.response);

    const data = error.response.data;
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN);
    if (error.response.status === 403) {
      Vue.notification.error({
        message: 'Forbidden',
        description: data.message,
      });
    }
    if (error.response.status === 401) {
      Vue.notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed',
      });
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
      }
    }
    if (data.error) {
      Vue.notification.error({
        message: data.error.code,
        description: data.error.message,
      });
    } else {
      Vue.$notification.error({
        message: 'error',
        description: data,
      });
    }
  }
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN);
  console.log('Request URL:', config.baseURL + config.url); // 打印实际请求地址
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    // config.headers[ACCESS_TOKEN] = `Bearer ${token}`;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use((response) => {
  return response.data;
}, errorHandler);

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request);
  },
};

export default request;

export { installer as VueAxios, request as axios };
